<div class="charts">
  <app-dashboard-chart1></app-dashboard-chart1>
  <app-dashboard-chart2></app-dashboard-chart2>
  <app-dashboard-chart3></app-dashboard-chart3>
  <app-dashboard-chart4></app-dashboard-chart4>
</div>
